import { Keyboard, StyleSheet, Text, TextInput, TouchableOpacity, View } from "react-native";

import { Colors } from "colors";
import ImageView from "../image";
import { Images } from "assets";
import React from "react";
import VText from "./VText";

const Input = ({
    placeholder = "",
    value = "",
    onChangeText = () => {},
    errorText = "",
    showIcon = false,
    iconName = "",
    iconPhone = "",
    propStyle = {},
    multiline = false,
    autoFocus = false,
    textInputProps = {},
    containerStyle = {},
    iconSearch = false,
    showCross = false,
    onPressCross = () => {},
    blurOnSubmit = false,
    placeholderTextColor = "#2124274D",
    inputContainerStyle = {},
    leftIcon = () => {},
    maxLength = 100000,
    onPressEnter = () => {},
    enableEnter = false,
}) => {
    return (
        <View style={[containerStyle]}>
            <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderWidth: 1,
                    borderColor: errorText ? Colors.red : value ? Colors.black60 : Colors.greyBorder,
                    padding: 16,
                    ...inputContainerStyle,
                }}
            >
                {showIcon && <>{leftIcon()}</>}
                <TextInput
                    autoFocus={autoFocus}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    
                    style={[
                        styles.input(errorText, showIcon, value),
                        propStyle,
                        { width: "100%", fontFamily: "JosefinSans", outlineStyle: "none" },
                    ]}
                    placeholderTextColor={placeholderTextColor}
                    onSubmitEditing={enableEnter ? onPressEnter : Keyboard.dismiss}
                    blurOnSubmit={blurOnSubmit}
                    value={value}
                    onChangeText={onChangeText}
                    multiline={multiline}
                    {...textInputProps}
                />
                {showCross && value?.length > 0 && (
                    <TouchableOpacity style={{ position: "absolute", right: 10 }} onPress={onPressCross}>
                        <ImageView
                            source={Images.clear}
                            style={{
                                width: 20,
                                height: 20,
                            }}
                        />
                    </TouchableOpacity>
                )}
            </View>

            {errorText && errorText != "" && <VText style={styles.errorText}>{errorText}</VText>}
        </View>
    );
};

export default Input;

const styles = StyleSheet.create({
    input: (errorText, showIcon, value) => ({
        fontSize: 15,
    }),
    errorText: {
        color: Colors.red,
        marginTop: 5,
        fontSize: 13,
    },
    iconStyle: {
        position: "absolute",
        paddingVertical: 16,
        paddingHorizontal: 16,
    },
});
